import { render, staticRenderFns } from "./UserDeleteRequest.vue?vue&type=template&id=2d897efd&"
import script from "./UserDeleteRequest.vue?vue&type=script&lang=js&"
export * from "./UserDeleteRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports